<!-- text -->
@if (component.text) {
@if (component.type === 'text') {
<href [link]="component.cta_link">
    <span class="w-12"
          [ngClass]="[component.align || '', component.text_style || '', component.color || '']"
          [style.color]="component?.textColor"
          *iCms="'text' of component; content: 'html'; tag: component.tag; skipEmpty: true"></span>
</href>
}
<!-- button -->
@if (component.type === 'button') {
<div class="w-12"
     [ngClass]="component.align">
    <href [link]="component.cta_link"
          [hrefTarget]="component.cta_target ? '_blank' : undefined">
        <button [ngClass]="component.button_class"
                type="button">
            <span *iCms="'text' of component"></span>
        </button>
    </href>
</div>
}
}